import { Carousel, Flex } from 'antd'
import Image from '@/components/image'
import { TextContent } from '../integration'
import imageMatter1 from '@/assets/img/solution/school-bus/matter-1.jpg'
import imageMatter2 from '@/assets/img/solution/school-bus/matter-2.jpg'
import imageMatter3 from '@/assets/img/solution/school-bus/matter-3.jpg'
import Styles from './style.module.scss'

const TITLE = 'Why This Matters'
const data = [
  {
    title: 'Policy Objectives',
    descriptions: ['California & U.S. states mandate 100% zero- emission school buses by 2035'],
  },
  {
    title: 'Scenario Implementation',
    descriptions: ['Target sites:School district depots, parking areas, community spaces'],
  },
  {
    title: 'Financial Support',
    descriptions: ['Significant federal & state subsidies available for both buses and charging infrastructure'],
  },
]
const swiperImages = [imageMatter1, imageMatter2, imageMatter3]

export default function Matter() {
  return (
    <div className={Styles.matter}>
      <h2>{TITLE}</h2>
      <Flex align='center' className={Styles.content}>
        <TextContent data={data} />
        <Carousel autoplay={{ dotDuration: true }} autoplaySpeed={5000} className={Styles.swiperWrapper}>
          {swiperImages.map((image, index) => (
            <div key={index}>
              <Image src={image} alt={`matter-${index}`} />
            </div>
          ))}
        </Carousel>
      </Flex>
    </div>
  )
}
